/**
 *
 */
function runBlockFlexslider(){

	var flexsliders = jQuery('.block-flexslider .flexslider');

	flexsliders.each(function(){

		var optionsAnimation = jQuery(this).data( 'options-animation' );
		var optionsPlayPause = Boolean(Number(jQuery(this).data( 'options-play-pause' )));
		var optionsPagination = Boolean(Number(jQuery(this).data( 'options-pagination' )));
		var optionsBeforeNext = Boolean(Number(jQuery(this).data( 'options-before-next' )));
		var optionsAutoplay = Boolean(Number(jQuery(this).data( 'options-autoplay' )));

		var optionsLapse = Number(jQuery(this).data( 'options-lapse' ));
		var optionsSpeed = Number(jQuery(this).data( 'options-speed' ));


		var options = {
			animation: optionsAnimation,
			pausePlay: optionsPlayPause,
			controlNav: optionsPagination,
			directionNav: optionsBeforeNext,
			slideshow: optionsAutoplay,
			slideshowSpeed: optionsLapse,
			animationSpeed: optionsSpeed,
			// default
			pauseOnHover: false
		};

		jQuery(this).flexslider(options)
	});

}
